import type { ReactNode } from "react";

import {
  HubPresenceAvatarStack,
  type HubPresenceAvatarPerson,
} from "@/components/HubPresenceAvatarStack";

/** Compact avatar stack for a single queue row when others are viewing that item. */
export function QueueItemPresenceAvatars(props: {
  people: HubPresenceAvatarPerson[];
  className?: string;
  labelPrefix?: string;
}): ReactNode {
  const { people, className, labelPrefix = "Viewing this request" } = props;
  if (people.length === 0) {
    return null;
  }
  return (
    <HubPresenceAvatarStack
      people={people}
      maxVisible={2}
      labelPrefix={labelPrefix}
      compact
      className={className}
    />
  );
}
